import { render, staticRenderFns } from "./ChangeTrainDialog.vue?vue&type=template&id=a8bba9ba&scoped=true"
import script from "./ChangeTrainDialog.vue?vue&type=script&lang=js"
export * from "./ChangeTrainDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeTrainDialog.vue?vue&type=style&index=0&id=a8bba9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bba9ba",
  null
  
)

export default component.exports